import '../css/app.css';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';

const appName = import.meta.env.VITE_APP_NAME || 'ReserveHub';

createInertiaApp({
    title: (title) => title ? title : appName,
    resolve: (name) => {
        const pages = import.meta.glob('./Pages/**/*.vue');

        return resolvePageComponent(`./Pages/${name}.vue`, pages).catch(() =>
            resolvePageComponent('./Pages/Error.vue', pages),
        );
    },
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) });
        
        // Global error handler to catch white screen issues
        app.config.errorHandler = (err, instance, info) => {
            console.error("Vue Global Error:", err);
            // If the app div is empty (white screen), print the error to the screen
            if (!el.innerHTML || el.innerHTML.trim() === '') {
                document.body.innerHTML = `
                    <div style="padding: 20px; font-family: sans-serif; background: #ffebee; color: #b71c1c; border: 1px solid #ffcdd2; margin: 20px; border-radius: 8px;">
                        <h2 style="margin-top:0;">Frontend Application Crashed</h2>
                        <p><strong>Error:</strong> ${err.message}</p>
                        <p><strong>Info:</strong> ${info}</p>
                        <pre style="background: rgba(255,255,255,0.7); padding: 10px; overflow: auto; border-radius: 4px; font-size: 12px;">${err.stack}</pre>
                    </div>
                `;
            }
        };

        return app
            .use(plugin)
            .use(ZiggyVue)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
